/*
 * @Description: 绩效审批节点配置
 * @Author: 杨志航
 * @Date: 2026-01-20 09:02:26
 */
import React, { useState, useEffect } from 'react'
import api from '@/api'
import {
  Form,
  message,
  Input,
  Table,
  Button,
  Select,
  Radio,
  Popconfirm,
} from 'antd'
import { allTrim, filterParams, generateUUID } from '@/utils'

const { Column } = Table
const FormItem = Form.Item
const Option = Select.Option

let searchParams = {
  limit: 9999, 
  page: 1
}

const AuditNode = (props) => {
  const { departList, groupList } = props
  const { getFieldDecorator, validateFields, setFieldsValue, getFieldsValue } = props.form

  const [loading, setLoading] = useState(false)
  const [list, setList] = useState([])
  const [name, setName] = useState('')

  useEffect(() => {
    getList()
  }, [])

  //获取已添加员工列表
  const getList = () => {
    setLoading(true)
    api.getAddStaffList(searchParams).then(res => {
      setList(res.list)
      setLoading(false)
    }).catch(() => { setLoading(false) })
  }

  const formSubmit = evt => {
    evt.preventDefault()
    resetParams()
    setFieldsValue(allTrim(getFieldsValue()))
    validateFields((err, vals) => {
      if (!err) {
        vals = filterParams(vals)
        searchParams = {...searchParams, ...vals}
        getList()
      }
    })
  }

  const onChangeName = evt => {
    setName(evt.target.value.trim())
  }

  const handleSearch = () => {
    setLoading(true)
    api.getAchievementsStaffList({
      name
    }).then(data => {
      setList(data.concat(list))
      setName('')
      setLoading(false)
    }).catch(() => setLoading(false))
  }

  const handleAdd = record => {
    const { id, auditNode } = record
    if (!auditNode) {
      return message.warning('请先选择审批节点')
    }
    setLoading(true)
    api.addAchievementsStaff({
      staffId: id,
      auditNode
    }).then(() => {
      resetParams()
      getList()
    }).catch(() => { setLoading(false) })
  }

  const handleDel = id => {
    setLoading(true)
    api.delAchievementsStaff({
      id
    }).then(() => {
      message.success('删除成功')
      getList()
    }).catch(() => { setLoading(false) })
  }

  const setAuditNode = (evt, index) => {
    list[index].auditNode = evt.target.value
    setList(list)
  }

  const updateAuditNode = (evt, id) => {
    setLoading(true)
    api.updateStaffAuditNode({
      id,
      auditNode: evt.target.value
    }).then(() => {
      setLoading(false)
      resetParams()
      getList()
    }).catch(() => {
      setLoading(false)
    })
  }

  const resetParams = () => {
    searchParams = {
      limit: 9999, 
      page: 1
    }
  }

  return (
    <div className="audit-node-super">
      <div className="search-super">
        <span style={{ marginRight: 10 }}>人员添加：</span>
        <Input 
          placeholder="请输入员工姓名或编号" 
          style={{ width: 300, marginRight: 10 }} 
          value={name}
          onChange={onChangeName} 
          onPressEnter={handleSearch}
          allowClear
        />
        <Button onClick={handleSearch} type="primary">搜索</Button>
      </div>
      <Form onSubmit={formSubmit} layout="inline">
        <FormItem label="员工姓名">
          {getFieldDecorator('staffName')(
            <Input 
              placeholder="请输入员工姓名" 
              style={{ width: '150px' }}
            />
          )}
        </FormItem>
        <FormItem label="所属部门">
          {getFieldDecorator('departmentId')(<Select 
            placeholder="请选择部门"
            showSearch
            allowClear
            filterOption={(input, option) => option.props.children?.toLowerCase().indexOf(input.toLowerCase()) >= 0}
            style={{ width: '150px' }}
          >
            {
              departList.map((item, index) => <Option key={index} value={item.id}>{item.name}</Option>)
            }
          </Select>)}
        </FormItem>
        <FormItem label="所属事业群">
          {getFieldDecorator('groupId')(<Select 
            placeholder="请选择事业群"
            showSearch
            allowClear
            filterOption={(input, option) => option.props.children?.toLowerCase().indexOf(input.toLowerCase()) >= 0}
            style={{ width: '150px' }}
          >
            {
              groupList.map((item, index) => <Option key={index} value={item.id}>{item.name}</Option>)
            }
          </Select>)}
        </FormItem>
        <FormItem label="">
          <Button type="primary" htmlType="submit">查询</Button>
        </FormItem>
      </Form>
      <Table
        dataSource={list}
        rowKey={() => generateUUID()}
        className="invoice-table"
        loading={loading}
        pagination={false}
      >
        <Column title="员工姓名" dataIndex="staffName" />
        <Column title="员工编号" dataIndex="staffNo" />
        <Column title="所属部门" dataIndex="departmentName" />
        <Column title="所属事业群" dataIndex="groupName" />
        <Column title="员工状态" dataIndex="isOnJob" />
        <Column 
          title="审批节点" 
          dataIndex="auditNode"
          align="center"
          width={200}
          render={(text, record, index) => 
            <>
              {record.staffId ? (
                <Radio.Group defaultValue={text} onChange={evt => updateAuditNode(evt, record.id)}>
                  <Radio value={1}>绩效部</Radio>
                  <Radio value={2}>内控部</Radio>
                </Radio.Group>
              ) : (
                <Radio.Group defaultValue={text} onChange={evt => setAuditNode(evt, index)}>
                  <Radio value={1}>绩效部</Radio>
                  <Radio value={2}>内控部</Radio>
                </Radio.Group>
              )}
            </>
          } 
        />
        <Column 
          title="操作"
          key="set" 
          align="center"
          width={80}
          render={(text, record) =>
            <>
              {record.staffId ? (
                <Popconfirm 
                  title="请确认是否删除？" 
                  onConfirm={() => handleDel(record.id)}
                >
                  <a>删除</a>
                </Popconfirm>
              ) : (
                <a onClick={() => handleAdd(record)}>添加</a>
              )}
            </>
          }
        />
      </Table>
    </div>
  )
}

export default Form.create()(AuditNode)